import { useState, type FormEvent } from 'react';

export default function Kontakt() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const hp = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value?.trim();
    if (hp) {
      setStatus('success');
      form.reset();
      return;
    }
    setStatus('submitting');
    setErrorMsg('');
    try {
      const data = new FormData(form);
      data.delete('website_alt');
      const response = await fetch('https://readdy.ai/api/form/dadept9tto0ceqqngg3g', {
        method: 'POST',
        body: data,
      });
      const responseText = await response.text();
      let parsed: any;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      if (!response.ok || parsed?.code !== 'OK' || (parsed?.meta?.message || '').toLowerCase().includes('spam')) {
        setStatus('error');
        setErrorMsg(parsed?.meta?.message || parsed?.meta?.detail || responseText || 'Ein Fehler ist aufgetreten.');
      } else {
        setStatus('success');
        form.reset();
      }
    } catch (err: any) {
      setStatus('error');
      setErrorMsg(err?.message || 'Netzwerkfehler.');
    }
  };

  return (
    <div className="min-h-screen py-16 md:py-24 px-4 md:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-12">
          Kontakt
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-6">
              Direkt Kontakt aufnehmen
            </h2>
            <div className="space-y-4 text-foreground-700">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 flex-shrink-0">
                  <i className="ri-phone-line text-primary-500"></i>
                </div>
                <div>
                  <p className="text-sm text-foreground-500">Telefon</p>
                  <a href="tel:023515691455" className="font-semibold hover:text-primary-500 transition-colors">
                    02351 5691455
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 flex-shrink-0">
                  <i className="ri-smartphone-line text-primary-500"></i>
                </div>
                <div>
                  <p className="text-sm text-foreground-500">Mobil</p>
                  <a href="tel:01752412769" className="font-semibold hover:text-primary-500 transition-colors">
                    0175 2412769
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 flex-shrink-0">
                  <i className="ri-mail-line text-primary-500"></i>
                </div>
                <div>
                  <p className="text-sm text-foreground-500">E-Mail</p>
                  <a href="mailto:info@klosek-metallbau.de" className="font-semibold hover:text-primary-500 transition-colors">
                    info@klosek-metallbau.de
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 flex-shrink-0">
                  <i className="ri-map-pin-line text-primary-500"></i>
                </div>
                <div>
                  <p className="text-sm text-foreground-500">Adresse</p>
                  <p className="font-semibold">
                    Römerweg 15<br />
                    58513 Lüdenscheid
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-10 p-6 bg-background-100 rounded-lg">
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-4">
                Öffnungszeiten
              </h3>
              <div className="space-y-2 text-sm text-foreground-700">
                <div className="flex justify-between">
                  <span>Mo - Do</span>
                  <span className="font-medium">7:00 - 18:00</span>
                </div>
                <div className="flex justify-between">
                  <span>Freitag</span>
                  <span className="font-medium">7:00 - 16:00</span>
                </div>
                <div className="flex justify-between">
                  <span>Sa - So</span>
                  <span className="font-medium">Nur nach Vereinbarung</span>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="w-full h-80 md:h-full min-h-[320px] rounded-lg overflow-hidden bg-background-100">
              <iframe
                title="Anfahrt Klosek Metallbau"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2500.0!2d7.60133!3d51.25181!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTHCsDE1JzA2LjUiTiA3wrAzNicwNC44IkU!5e0!3m2!1sde!2sde!4v1700000000000!5m2!1sde!2sde"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>

        <div id="formular" className="mt-16 max-w-2xl mx-auto">
          <h2 className="text-2xl font-heading font-bold text-foreground-950 text-center mb-8">
            Kontaktformular
          </h2>
          <form data-readdy-form="dadept9tto0ceqqngg3g" onSubmit={handleSubmit} className="space-y-5">
            <div className="ui-wrapper">
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
            </div>
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1">
                Name *
              </label>
              <input
                type="text"
                id="name"
                name="name"
                required
                className="w-full px-4 py-2.5 rounded-md border border-background-200 bg-background-50 text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400"
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1">
                E-Mail *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                className="w-full px-4 py-2.5 rounded-md border border-background-200 bg-background-50 text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400"
              />
            </div>
            <div>
              <label htmlFor="phone" className="block text-sm font-medium text-foreground-700 mb-1">
                Telefon
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                className="w-full px-4 py-2.5 rounded-md border border-background-200 bg-background-50 text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400"
              />
            </div>
            <div>
              <label htmlFor="subject" className="block text-sm font-medium text-foreground-700 mb-1">
                Betreff
              </label>
              <input
                type="text"
                id="subject"
                name="subject"
                className="w-full px-4 py-2.5 rounded-md border border-background-200 bg-background-50 text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400"
              />
            </div>
            <div>
              <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1">
                Nachricht
              </label>
              <textarea
                id="message"
                name="message"
                maxLength={500}
                rows={4}
                className="w-full px-4 py-2.5 rounded-md border border-background-200 bg-background-50 text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 resize-y"
              />
              <p className="text-xs text-foreground-500 mt-1">Max. 500 Zeichen</p>
            </div>
            <button
              type="submit"
              disabled={status === 'submitting'}
              className="w-full px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-md hover:bg-primary-600 transition-colors disabled:opacity-60"
            >
              {status === 'submitting' ? 'Wird gesendet...' : 'Nachricht senden'}
            </button>
            {status === 'success' && (
              <div className="bg-primary-50 text-primary-700 p-3 rounded-md text-center text-sm font-medium">
                Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet.
              </div>
            )}
            {status === 'error' && (
              <div className="bg-background-100 text-foreground-700 p-3 rounded-md text-center text-sm font-medium border border-background-200">
                {errorMsg}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}